/* eslint-disable prefer-const */
/* eslint-disable no-param-reassign */
import { api } from 'portal-common/http';
import Cookie from 'portal-common-account/src/utils/cookie';
import { isBrowser } from 'portal-common-account/src/utils/device';
import { getRealHostName } from 'portal-common-account/src/utils/host';
import loginUtil from 'portal-common-account/src/utils/login';
import { addParamsToUrl } from 'portal-common-account/src/utils/url';

function getApiPrefix() {
  const hostname = getRealHostName();
  const port = isBrowser() ? location.port : '';
  const API_BASE = `https://${hostname}${port}`;

  const language = Cookie.get('language') || 'en';
  return `${API_BASE}/${language}`;
}

const API_PREFIX = getApiPrefix();

export function baseCall(url, options) {
  const data = options.body || options.data;
  return apiCallReturn(
    api.call(`${API_PREFIX}${url}`, {
      ...options,
      method: options.method || 'post',
      isOpenResDataCheck: false,
      body: data,
    }),
  );
}

export function baseCallWithUser(url, options) {
  const data = options.body || options.data;
  const params = {};
  const uin = loginUtil.getUin();
  const csrf = loginUtil.getCsrfCode();
  if (uin) {
    params.uin = uin;
  }
  if (csrf) {
    params.csrf = csrf;
  }
  const finalUrl = addParamsToUrl(`${API_PREFIX}${url}`, params);
  return apiCallReturn(
    api.call(finalUrl, {
      ...options,
      method: options.method || 'post',
      isOpenResDataCheck: false,
      body: data,
    }),
  );
}

export function baseRequest(url, params) {
  return addParamsToUrl(`${API_PREFIX}${url}`, params);
}

async function apiCallReturn(fn) {
  try {
    const ret = await fn;
    if (ret.code !== 0) {
      throw ret;
    }
    return Promise.resolve(ret);
  } catch (err) {
    return Promise.reject(err);
  }
}
